import { Navigate, Outlet, useLocation } from "react-router-dom";

import { type ProductModuleKey, useProductModules } from "@/client/services/product-modules";

type Props = {
  module: ProductModuleKey;
};

/**
 * Pages of a module an admin has hidden send the user to the dashboard, quietly. Wrap only a
 * module's own pages: links other flows depend on (theRecruit's interview invite and the
 * interview room) must stay outside.
 */
export const ModuleGuard = ({ module }: Props) => {
  const { modules } = useProductModules();
  const { search } = useLocation();

  if (!modules) return null;
  if (!modules[module]) {
    // A plan picked on firstround.com.au still opens the plan dialog on the dashboard.
    const params = new URLSearchParams(search);
    const kept = new URLSearchParams();
    for (const key of ["plan", "code", "plans"]) {
      const value = params.get(key);
      if (value !== null) kept.set(key, value);
    }
    const query = kept.toString();
    return <Navigate to={query ? `/dashboard?${query}` : "/dashboard"} replace />;
  }

  return <Outlet />;
};
